import { ButtonGroup, TextLink } from '@oneaudi/unified-web-components';
import React from 'react';
import { UeElement } from '@oneaudi/falcon-tools';
import type { LinkProps } from '../../../types';
import type { TrackingClickEvent } from '../../tracking';
import { useTracking } from '../../tracking';
import { Context } from '../../Context';

export interface CTAsProps {
  readonly links: LinkProps[];
  headline: string;
}

const CTAs: React.FC<CTAsProps> = ({ links, headline }: CTAsProps) => {
  if (links.length === 0) {
    return null;
  }

  const { trackingService } = React.useContext(Context);
  const { sendClickEvent } = useTracking(trackingService);

  return (
    // @ts-expect-error  Buttons does produce  multiple children
    <ButtonGroup
      data-testid="ctas"
      size="md"
      margin={['var(--spacing-relative-lg)', 0, 'var(--spacing-relative-lg)', 0]}
    >
      {links.map(({ href, text, label, openInTabOrLayer }, i) => {
        return (
          <TextLink
            size="md"
            margin={[0, 'var(--spacing-relative-md)', 0, 0]}
            variant="standalone"
            href={href}
            target={openInTabOrLayer === 'tab' ? '_blank' : undefined}
            rel={openInTabOrLayer === 'tab' ? 'noopener noreferrer' : undefined}
            icon="forward"
            iconPosition="trailing"
            aria-label={label}
            key={`${i}-${text}`}
            data-testid="cta"
            onClick={() => {
              const event: TrackingClickEvent = {
                linkLabel: text,
                linkUrl: href,
                elementName: 'text link',
                headline,
                clickEventName: 'click on text link',
              };
              sendClickEvent(event);
            }}
          >
            <UeElement type="text" property={`links_${i}_text`} label={`Label (${i + 1})`}>
              {text}
            </UeElement>
          </TextLink>
        );
      })}
    </ButtonGroup>
  );
};

export default CTAs;
